import React from "react";
import { AmlExplanatoryNotes2 } from "../../reportSections/aml/amlExplanatoryNotes";
import { apiGet, apiPost } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from "../../common/loadingComponent";
import { connect } from "react-redux";
import { isNullOrUndefined } from "../../../store/storeFunctions";
import { popupActions } from '../../../store/popupStore';
import { Redirect } from 'react-router';
import { registrySearchActions, REGISTRY } from '../../../store/ceeSearchStore';
import { Translate, withLocalize } from "react-localize-redux";
import AmlGlobalEval from "../../reportSections/aml/amlGlobalEval";
import AmlPersonDetail from "./amlPersonDetail";
import AmlReportDateInformation from "./amlReportDateInformation";
import AmlSearchCriteria from "./amlSearchCriteria";
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import SvgRefresh from "../../../img/icons/Refresh";

class AmlPerson extends React.Component {
    state = { data: null, loading: false, responseData: null, refreshReqInit: false }
    timer = null;

    render() {
        if (this.state.loading)
            return <Circles />;

        if (isNullOrUndefined(this.state.data))
            return <NoDataComponent />;

        if (this.state.refreshReqInit && this.props.cee[REGISTRY.aml].requestResult)
            return <Redirect to='/search/aml/results' />;

        var agentLanguage = this.props.user.authentication.profile.agentLanguage;
        return (
            <React.Fragment>
                {this.state.data !== null && !this.state.loading &&
                    <React.Fragment>
                        {this.renderErrors()}
                        <AmlReportDateInformation inserted={this.state.data.insertedFormated} completed={this.state.data.completedFormated} profile={this.state.data.amlProfileName} />
                        <AmlSearchCriteria search={this.state.data.searchParams} asSection />
                        <div className="card">
                            <div className="card-body">
                                <div className="aml-available">
                                    <div className="columns">
                                        <div className="column is-narrow" style={{ display: "flex", alignItems: "center" }}>
                                            <SvgRefresh className="refresh-icon" />
                                            <div style={{ justifyContent: "flex-start" }} className="link-internal" onClick={() => this.updateData()}>
                                                <Translate id="Report.Aml.UpdateData" />
                                            </div>
                                        </div>
                                    </div>
                                    <AmlGlobalEval data={this.state.data} decision={this.state.data.decision} expanded={true} />
                                    <table className="table table-report-section-3">
                                        <thead>
                                            <tr>
                                                <th />
                                                <th><Translate id="Report.Aml.Subjects.Candidate" /></th>
                                                <th><Translate id="Report.Aml.Subjects.PercentOfConfidence" /></th>
                                                <th><Translate id="Report.Aml.Subjects.DateOfBirth" /></th>
                                                <th><Translate id="Report.Aml.Subjects.PlaceOfBirth" /></th>
                                                <th><Translate id="Report.Aml.Subjects.Source" /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.candidates.map((c) => {
                                                return (
                                                    <AmlPersonDetail key={c.key} candidate={c} hasBirthDate={!isNullOrUndefined(this.state.data.searchParams.birthDate)} />
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    <AmlExplanatoryNotes2 data={this.state.data} />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                }
                <div className="disclaimer-wrapper">
                    <div className="disclaimer-gray"><Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} /></div>
                </div>
            </React.Fragment>
        )
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.id != this.props.match.params.id) {
            this.getData();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    getData() {
        this.setState({ loading: true });
        this.props.setResultsRequestParams(REGISTRY.aml, null);

        apiGet(`${window.babylonApiUrl}/api/search/aml/request-fo/${this.props.match.params.id}`, null, (res) => this.onSuccess(res.data), () => { });
    }

    onSuccess = (data) => {
        this.setState({ data: data, loading: false });

        if (!isNullOrUndefined(data)) {
            this.props.setResultsRequestParams(REGISTRY.aml, { subPath: 'request-fo', id: parseInt(this.props.match.params.id), params: null });
        }
    }

    getSearchData(isFPo) {
        const searchParams = this.state.data.searchParams;
        let searchData = null;
        if (isFPo) {
            searchData = {
                name: isNullOrUndefined(searchParams.lastName) ? null : searchParams.lastName,
                country: isNullOrUndefined(searchParams.countryCode) ? null : searchParams.countryCode,
                birthDate: isNullOrUndefined(searchParams.birthDate) ? null : searchParams.birthDate,
            };
        } else {
            searchData = {
                firstName: isNullOrUndefined(searchParams.firstName) ? null : searchParams.firstName,
                surname: isNullOrUndefined(searchParams.lastName) ? null : searchParams.lastName,
                city: isNullOrUndefined(searchParams.city) ? null : searchParams.city,
                middleName: isNullOrUndefined(searchParams.middleName) ? null : searchParams.middleName,
                gender: isNullOrUndefined(searchParams.gender) ? null : searchParams.gender,
                country: isNullOrUndefined(searchParams.countryCode) ? null : searchParams.countryCode,
                birthDate: isNullOrUndefined(searchParams.birthDate) ? null : searchParams.birthDate,
            };
        }
        return searchData;
    }

    isFPo() {
        const searchParams = this.state.data.searchParams;
        return isNullOrUndefined(searchParams.firstName) || isNullOrUndefined(searchParams.lastName);
    }

    updateData() {
        const isFpo = this.isFPo();
        var generatedDataForServer = this.getSearchData(isFpo);
        generatedDataForServer.oldRequestDate = this.state.data.completed;
        apiPost(
            `${window.babylonApiUrl}/api/search/aml/check/${isFpo ? 'fpo' : 'fo'}`,
            null,
            generatedDataForServer,
            (res) => {
                if (res.data.isSuccess) {
                    if (isNullOrUndefined(res.data.id))
                        this.confirmationPopup();
                    else {
                        const path = `/search/aml/results/person/${res.data.id}`;
                        if (res.data.isCustomerRequest)
                            this.decisionPopup(generatedDataForServer, res.data.requestDateFormatted, path);
                        else
                            this.props.history.push(path);
                    }
                }
                else
                    this.onError(res.data);
            },
            (err) => this.onError(err.data)
        );
    }

    confirmationPopup() {
        this.props.showPopup('updateAmlData', {
            open: true,
            close: () => this.props.hidePopup(),
            onSubmitAmlRequest: () => this.initiateRequest(),
            data: this.state.data,
            asCompany: false
        });
    }

    initiateRequest() {
        if (this.isFPo()) {
            var searchData = this.getSearchData(true);
            searchData.forceNewRequest = true;
            this.props.initiateCeeRequestOnFpo(REGISTRY.aml, REGISTRY.aml, searchData);
        } else {
            var searchData = this.getSearchData(false);
            searchData.forceNewRequest = true;
            this.props.initiateCeeRequestOnFo(REGISTRY.aml, REGISTRY.aml, searchData);
        }
        this.setState({ refreshReqInit: true });
    }

    decisionPopup = (generatedDataForServer, requestDate, continuePath) => {
        this.props.showPopup('ceeDecision', {
            title: this.props.translate('Common.Information'),
            open: true,
            close: () => { this.props.hidePopup(); },
            requestDate: requestDate,
            continue: () => {
                //re-use the old request  
                if (!isNullOrUndefined(continuePath) && continuePath !== '')
                    this.props.history.push(continuePath);
                else
                    this.props.hidePopup();
            },
            newRequest: () => {
                this.props.hidePopup();
                generatedDataForServer.forceNewRequest = true;
                //check credit to get accurate price and create a new request
                apiPost(
                    `${window.babylonApiUrl}/api/search/aml/check/${this.isFPo() ? 'fpo' : 'fo'}`,
                    null,
                    generatedDataForServer,
                    (res) => {
                        if (res.data.isSuccess) {
                            if (isNullOrUndefined(res.data.requestId))
                                this.confirmationPopup();
                            else
                                this.props.history.push(continuePath);
                        } else
                            this.onError(res.data);
                    },
                    (err) => this.onError(err.data)
                );
            }
        });
    }

    onError = (data) => this.setState({ responseData: data });

    renderErrors = () => {
        const resData = this.props.cee[REGISTRY.aml].responseData;
        const stateResData = this.state.responseData;

        if (this.props.cee[REGISTRY.aml].requestResult === false && this.hasError(resData) || this.hasError(stateResData)) {
            return (
                <div style={{ marginTop: "1em" }}>
                    {((!isNullOrUndefined(resData) && !isNullOrUndefined(resData.exception)) || (!isNullOrUndefined(stateResData) && !isNullOrUndefined(stateResData.exception))) &&
                        <Message type="error" message="">
                            {!isNullOrUndefined(stateResData) && !!stateResData.exception
                                ? <Translate options={{ renderInnerHtml: true }} id={stateResData.exception} data={isNullOrUndefined(stateResData.exceptionData) ? undefined : stateResData.exceptionData} />
                                : <Translate options={{ renderInnerHtml: true }} id={resData.exception} data={isNullOrUndefined(resData.exceptionData) ? undefined : resData.exceptionData} />}
                        </Message>}

                    {((!isNullOrUndefined(resData) && !!resData.error) || (!isNullOrUndefined(stateResData) && !!stateResData.error)) &&
                        <Message type="error" message="">
                            {!isNullOrUndefined(stateResData) && !!stateResData.error
                                ? <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(stateResData.error.message) ? stateResData.error : stateResData.error.message} />
                                : <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(resData.error.message) ? resData.error : resData.error.message} />}
                        </Message>}
                </div>
            );
        }
    }

    hasError = (data) => !isNullOrUndefined(data) && (!isNullOrUndefined(data.exception) || !isNullOrUndefined(data.errorFile) || !!data.error);
}

export default withLocalize(connect(
    state => { return { cee: state.registrySearch, user: state.userContext } },
    dispatch => bindActionCreators({ ...registrySearchActions, ...popupActions }, dispatch)
)(AmlPerson));